export default __webpack_public_path__ + "static/SCROLL_11-20eb9953bca8c8a4e7eee46762d465d3.png";